import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { Modal } from "../../core/components/Modal";
import { Font, FontWeight, TextElement } from "../../core/components/TextElement";
export const Contact3DLastGameSummaryModal = (props) => {
    const { lastGameSummary } = props;
    const [showModal, setShowModal] = useState(true);
    if (!lastGameSummary || !showModal) {
        return null;
    }
    const titleText = (lastGameSummary === null || lastGameSummary === void 0 ? void 0 : lastGameSummary.gameEndReason) === 'GameFinished' ? 'Game over' : 'Not enough players';
    const bodyText = getBodyText(lastGameSummary);
    const secretWordText = getSecretWordText(lastGameSummary);
    return _jsxs(Modal, { gap: '30px', onClose: () => { setShowModal(false); }, style: { width: '700px', height: '400px', padding: '48px', borderColor: '#a1d3f7', backgroundColor: '#daeaf577' }, children: [_jsx(TextElement, { font: Font.Inter, fontWeight: FontWeight.Bold, fontSize: 36, text: titleText, color1: "#000000", centered: true }), _jsx(TextElement, { font: Font.Inter, fontWeight: FontWeight.Medium, fontSize: 25, text: bodyText, color1: "#000000" }), secretWordText !== undefined && _jsx(TextElement, { font: Font.Inter, fontWeight: FontWeight.Medium, fontSize: 25, text: secretWordText, color1: "#000000" })] });
};
function getBodyText(lastGameSummary) {
    if (lastGameSummary.gameEndReason === 'GameFinished') {
        return `Guessers found out the secret word.`;
    }
    else if (lastGameSummary.gameEndReason === 'NotEnoughPlayers') {
        return `The game was closed because players left. There must be at least 3 players to play.`;
    }
    else if (lastGameSummary.gameEndReason === 'SecretWordGiverLeft') {
        return `The game was closed because the mastermind left.`;
    }
}
function getSecretWordText(lastGameSummary) {
    const secretWord = lastGameSummary.details.secretWord;
    return secretWord !== undefined ? `\nThe secret word was: ${secretWord}.` : undefined;
}
//# sourceMappingURL=Contact3DLastGameSummaryModal.js.map